import React from "react";
import "./Ecosystem.css";

const ecosystemLogos = [
  {
    name: "MegaVolt Productions",
    src: "/ecosystem/megavolt.png",
  },
  {
    name: "VSN Academy",
    src: "/ecosystem/vsn-academy.png",
  },
  {
    name: "Spring to Delta",
    src: "/ecosystem/spring-to-delta.png",
  },
  {
    name: "Agent Calyweba",
    src: "/ecosystem/agent-calyweba.png",
  },
  {
    name: "Hydraulic",
    src: "/ecosystem/hydraulic.png",
  },
];

const Ecosystem = () => {
  return (
    <section className="ecosystem-section">
      <div className="ecosystem-inner">
        <h3 className="ecosystem-title">
          Powered by the <span>VSN Ecosystem</span>
        </h3>

        <div className="ecosystem-grid">
          {ecosystemLogos.map((logo) => (
            <div className="ecosystem-logo" key={logo.name}>
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
        </div>

        <p className="ecosystem-note">
          Independent initiatives developed within the Virtual Scouting Network
          vision.
        </p>
      </div>
    </section>
  );
};

export default Ecosystem;
